import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  SEARCHING_STREAMS_REQUEST, SEARCHING_STREAMS_SUCCEEDED, SEARCHING_STREAMS_FAILED,
  INVALIDATE_STREAMS_SEARCH
}
  from 'constants/actionTypes.jsx';

import _ from 'lodash';

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  stream: {},
  group: {},
  search: {
    searching: false,
    query: '',
    items: [],
    pagination: {
      current: -1,
      totalPages: 1
    }
  },
}

const entityState = {
  loading: false,
  item: null
}

function hubReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_HUB_STREAMS_REQUEST:
      return {
        ...state,
        loading: true,
        invalidated: true
      }
    case FETCHING_HUB_STREAMS_SUCCEEDED:
      var items = _.sortBy(action.payload, stream => stream.name.toLowerCase());

      return {
        ...state,
        loading: false,
        invalidated: false,
        items: items
      }
    case FETCHING_HUB_STREAMS_FAILED:
      return {
        ...state,
        loading: false,
        invalidated: false
      }
    case FETCHING_STREAM_REQUEST:
      var id = action.payload;
      var stream = state.stream[id] || entityState;
      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: true,
            invalidated: true
          }
        }
      }
    case FETCHING_STREAM_SUCCEEDED:

      var id = action.payload.id;
      var stream = state.stream[id] || entityState;

      var items = action.payload.response.children || [];

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];

      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: {
              ...action.payload.response,
              children: sortedChildren
            }
          }
        }
      }
    case FETCHING_STREAM_FAILED:
      var id = action.payload.id;
      var stream = state.stream[id] || entityState;
      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: null,
            errors: action.payload.error.errors
          }
        }
      }
    case FETCHING_GROUP_REQUEST:
      var id = action.payload;
      var group = state.group[id] || entityState;
      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: true,
            invalidated: true
          }
        }
      }
    case FETCHING_GROUP_SUCCEEDED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      var items = action.payload.response.children || [];

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: false,
            item: {
              ...action.payload.response,
              children: sortedChildren
            }
          }
        }
      }

    case FETCHING_GROUP_FAILED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      return {
        ...state,
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: true
          }
        }
      }

    case SEARCHING_STREAMS_REQUEST:
      return{
        ...state,
        searching: true,
        query: action.payload.query,
        search: {
          ...state.search,
          searching: true
        }
      }

    case SEARCHING_STREAMS_SUCCEEDED:
      var query = action.payload.query;
      var response = action.payload.response;

      var items = [];
      if (response.currentPage == 0) {
        items = response.records;
      } else {
        items = [...state.search.items, ...response.records];
      }

      items = _.uniqBy(items, (a) => {
        return a.id;
      });

      return{
        ...state,
        search: {
          ...state.search,
          items: items,
          searching: false,
          query: query,
          pagination: {
            ...state.search.pagination,
            current: action.payload.response.currentPage,
            totalPages: action.payload.response.totalPages
          }
        }
      }

    case SEARCHING_STREAMS_FAILED:
      return{
        ...state,
        search: {
          searching: false,
          query: '',
          items: [],
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      };

    case INVALIDATE_STREAMS_SEARCH:
      return{
        ...state,
        search: {
          searching: false,
          query: '',
          items: [],
          pagination: {
            current: -1,
            totalPages: 1
          }
        }
      };


    default:
      return state
  }
}

export { hubReducer };